export const SHOW_MODAL_CONTROLLER = 'app/SHOW_MODAL_CONTROLLER';
export const CLOSE_MODAL_CONTROLLER = 'app/CLOSE_MODAL_CONTROLLER';

export enum ModalTypes {
  DELETE_BLOCK = 'deleteBlockModal',
  HIDE_START_PAGE = 'hideStartPageModal',
  UNEDITABLE_VERSION = 'uneditableVersion',
  STUDIO_KEYBOARD_SHORTCUTS = 'studioKeyboardShortcuts',
  NO_INPUT_VARIABLE_START_PAGE = 'noInputVariableStartPage',
}
